<template>
  <div v-html="content" v-loading="loading"></div>
</template>

<script>
export default {
  data(){
    return{
      content:'',
      loading:false
    }
  },
  created(){
    this.getInfo();
  },
  methods:{
    getInfo(){
      this.loading = true;
      this.$http.get(this.$api.systemApi.ZxDetail).then(({ data }) => {
        this.loading = false;
        this.content = data.data.content;
      }).catch(()=>{
        this.loading = false;
        this.content = '';
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
